<header id="topnav" class="app-header">
  <a
    class="app-header__brand"
    routerLink="dashboard"
    data-cy="organization-logo"
  >
    <img
      [src]="
        user?.getOrganizationLogoUrl() || 'assets/app/img/quotiss_logo.png'
      "
      alt="Organization"
    />
  </a>

  <div class="app-header__main">
    <div class="app-header__top">
      <a
        class="app-header__wordmark"
        routerLink="dashboard"
        data-cy="main-logo"
      >
        <img alt="Quotiss" src="assets/app/img/quotiss_logo-dark.png" />
      </a>

      @if (user) {
        <div class="app-header__account">
          <a
            class="app-header__toggle navbar-toggle"
            [class.open]="navVisible"
            role="button"
            tabindex="0"
            aria-label="Menu"
            aria-controls="navigation"
            [attr.aria-expanded]="navVisible"
            (keydown.enter)="toggleNav()"
            (keydown.space)="$event.preventDefault(); toggleNav()"
          >
            <div class="lines"><span></span> <span></span> <span></span></div>
          </a>
          <app-notification-dropdown></app-notification-dropdown>
          <app-user-menu [user]="user"></app-user-menu>
        </div>
      }
    </div>

    @if (user) {
      <div class="app-header__nav">
        <app-nav [user]="user" [opened]="navVisible"></app-nav>

        <div class="app-header__tools">
          <span
            class="app-header__guide"
            *ngxPermissionsOnly="role.salesIndividualView"
          >
            <p-toggleswitch
              [(ngModel)]="userGuideOn"
              (onChange)="emitUserProgressToggle()"
              inputId="user-guide-switch"
              data-cy="user-progress-trigger"
            ></p-toggleswitch>
            <label for="user-guide-switch">User guide</label>
          </span>

          <a
            class="app-header__helpdesk"
            [href]="helpdeskUrl"
            target="_blank"
            rel="noopener"
          >
            <i class="pi pi-info-circle"></i> Helpdesk
          </a>

          <button
            type="button"
            class="app-header__help"
            aria-label="Help"
            (click)="openSupport()"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M5.33333 6.00033H10.6667M5.33333 8.66699H9.33333M9.33333 12.0003H8.66667L5.33333 14.0003V12.0003H4C3.46957 12.0003 2.96086 11.7896 2.58579 11.4145C2.21071 11.0395 2 10.5308 2 10.0003V4.66699C2 4.13656 2.21071 3.62785 2.58579 3.25278C2.96086 2.87771 3.46957 2.66699 4 2.66699H12C12.5304 2.66699 13.0391 2.87771 13.4142 3.25278C13.7893 3.62785 14 4.13656 14 4.66699V7.66699M12.6667 14.667V14.6737M12.6667 12.667C12.9655 12.666 13.2554 12.5649 13.49 12.3796C13.7245 12.1944 13.8902 11.9359 13.9604 11.6454C14.0306 11.3548 14.0013 11.0492 13.8772 10.7773C13.7531 10.5054 13.5414 10.283 13.276 10.1457C13.0108 10.0098 12.7074 9.96768 12.4152 10.0261C12.123 10.0846 11.8592 10.2402 11.6667 10.4677"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    }
  </div>
</header>
